var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookOpen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.533203 1.99995C0.533203 1.55812 0.891375 1.19995 1.3332 1.19995H5.3332C6.25262 1.19995 7.13438 1.56519 7.78451 2.21531C8.43463 2.86544 8.79987 3.7472 8.79987 4.66662V14C8.79987 14.4418 8.4417 14.8 7.99987 14.8C7.55804 14.8 7.19987 14.4418 7.19987 14C7.19987 13.6817 7.07344 13.3765 6.8484 13.1514C6.62335 12.9264 6.31813 12.8 5.99987 12.8H1.3332C0.891375 12.8 0.533203 12.4418 0.533203 12V1.99995ZM7.19987 11.4701V4.66662C7.19987 4.17155 7.0032 3.69675 6.65314 3.34669C6.30307 2.99662 5.82827 2.79995 5.3332 2.79995H2.1332V11.2H5.99987C6.41894 11.2 6.82833 11.2939 7.19987 11.4701Z",
    fill: "#506D95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21556 2.21531C8.86568 1.56519 9.74744 1.19995 10.6669 1.19995H14.6669C15.1087 1.19995 15.4669 1.55812 15.4669 1.99995V12C15.4669 12.4418 15.1087 12.8 14.6669 12.8H10.0002C9.68194 12.8 9.37671 12.9264 9.15167 13.1514C8.92662 13.3765 8.8002 13.6817 8.8002 14C8.8002 14.4418 8.44202 14.8 8.0002 14.8C7.55837 14.8 7.2002 14.4418 7.2002 14V4.66662C7.2002 3.7472 7.56543 2.86544 8.21556 2.21531ZM8.8002 11.4701C9.17174 11.2939 9.58112 11.2 10.0002 11.2H13.8669V2.79995H10.6669C10.1718 2.79995 9.697 2.99662 9.34693 3.34669C8.99686 3.69675 8.8002 4.17155 8.8002 4.66662V11.4701Z",
    fill: "#506D95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpen);
export default __webpack_public_path__ + "static/media/book-open.c499343ecd5b12a5d2699cb0182b3a3c.svg";
export { ForwardRef as ReactComponent };